// import React from 'react';
// import Renegociacao25 from '../components/templates/Renegociacao25';

// function RenegociacaoPage() {
//   return <Renegociacao25 />;
// }

// export default RenegociacaoPage;

import TabGroupRenegociacao from '@/components/molecules/TabGroupRenegociacao/TabGroupRenegociacao';
import { RenegociacaoTabs } from '@/data/misc/RenegociacaoTabs';

export default function renegociacaoSantanderEmprestimos() {
  return <TabGroupRenegociacao tab={RenegociacaoTabs['renegociacao-santander-emprestimos'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
